<template>
  <div>
    <b-sidebar
      id="sidebar-filter"
      v-model="showSlide"
      backdrop
      shadow
      backdrop-variant="dark"
      right
      aria-labelledby="sidebar-filter-title"
      @hidden="hide()"
      no-header
    >
      <template>
        <div>
          <div
            class="px-2 py-3 d-flex justify-content-between align-items-center"
          >
            <label class="ml-2 mb-0 header-text">กรองข้อมูล</label>
            <label class="m-0 pr-2 pointer" @click="hide"
              ><b-icon icon="x-circle-fill"></b-icon
            ></label>
          </div>
          <div>
            <div class="p-2 detail-panel">
              <InputText
                textFloat="หมายเลขสมาชิก (Member ID)"
                v-model="filter.memberId"
                class="p-2 m-0"
                placeholder="Member ID"
                type="text"
              />
              <InputText
                textFloat="ชื่อสมาชิก (Member Name)"
                v-model="filter.name"
                class="p-2 m-0"
                placeholder="Name"
                type="text"
              />
              <InputText
                textFloat="หมายเลขโทรศัพท์ (Phone No.)"
                v-model="filter.telephone"
                class="p-2 m-0"
                placeholder="Phone No."
                type="text"
              />
              <div class="p-2">
                <div class="font-weight-bold">
                  ระดับสมาชิก (Member tier)
                </div>
                <b-row class="p-2">
                  <b-col cols="12" class="my-1">
                    <b-form-checkbox
                      v-model="selectMemberLevelAll"
                      @change="selectAll"
                    >
                      All
                    </b-form-checkbox>
                  </b-col>
                  <b-col
                    v-for="(m, index) in MemberOption"
                    :key="index"
                    cols="6"
                    class="my-1"
                  >
                    <b-form-checkbox
                      v-model="filter.memberLevel"
                      :value="m.value"
                    >
                      {{ m.text }}
                    </b-form-checkbox>
                  </b-col>
                </b-row>
              </div>
            </div>
          </div>
        </div>
      </template>

      <template #footer>
        <div class="text-center">
          <div
            class="px-3 my-3 w-100 d-flex justify-content-between align-items-center"
          >
            <p @click="clearFilter"><u>ล้างตัวกรอง</u></p>
            <b-button
              class="radius-btn w-50"
              :style="
                `${$store.state.backgroundPrimary}color: ${$store.state.colorSecondary};`
              "
              @click="submitForm"
              ><span>ค้นหา</span></b-button
            >
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
export default {
  name: "SlideFilter",
  components: { InputText },
  props: {
    filter: {
      type: Object,
      isRequired: true,
    },
  },
  data() {
    return {
      showSlide: false,
      selectMemberLevelAll: true,
      MemberOption: [
        {
          text: "Member",
          value: 1,
        },
        {
          text: "Non-Member",
          value: 23,
        },
      ],
    };
  },
  watch: {
    "filter.memberLevel": {
      handler(val) {
        if (this.filter.memberLevel.length == this.MemberOption.length) {
          this.selectMemberLevelAll = true;
        } else {
          this.selectMemberLevelAll = false;
        }
      },
    },
  },
  methods: {
    show() {
      this.showSlide = true;
    },
    hide() {
      this.showSlide = false;
    },
    selectAll(value) {
      if (value) {
        this.filter.memberLevel = this.MemberOption.map((m, i) => {
          return m.value;
        });
      } else {
        this.filter.memberLevel = [];
      }
    },
    async clearFilter() {
      this.filter.memberId = "";
      this.filter.name = "";
      this.filter.telephone = "";
      this.filter.member_level = [];
      this.filter.page = 1;
      this.filter.perPage = 8;
      this.$emit("onSubmitFilter");
    },
    async submitForm() {
      await this.$emit("onSubmitFilter");
      this.hide();
    },
  },
};
</script>

<style scoped>
.input-container {
  display: flex;
  height: 100%;
  padding: 0.5rem;
  background-color: white;
  border: 1px solid #bcbcbc;
  border-radius: 6px;
  align-items: center;
  justify-content: space-between;
}
</style>
